export const SET_USER = 'SET_USER' //添加用户信息
export const SET_CSNDIDATE = 'SET_CSNDIDATE' // 候选人信息